"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewPrivacyService = void 0;
class ReviewPrivacyService {
    /**
     * Filter reviews based on privacy settings and viewer relationship
     */
    static filterReviewsForViewer(reviews, viewerUserId, reviewOwnerUserId) {
        return reviews.filter(review => {
            if (!viewerUserId) {
                return review.reviewVisibility === 'anyone' || !review.reviewVisibility;
            }
            if (viewerUserId === review.userId) {
                return true;
            }
            switch (review.reviewVisibility || 'anyone') {
                case 'anyone':
                    return true;
                case 'only-me':
                    return false;
                default:
                    return true;
            }
        });
    }
    /**
     * Filter user movie data based on privacy settings for display in lists
     */
    static filterUserMovieDataForViewer(movieData, viewerUserId, dataOwnerUserId) {
        return movieData.map(data => {
            if (viewerUserId === dataOwnerUserId) {
                return data;
            }
            const filteredData = Object.assign({}, data);
            if (data.review && data.reviewVisibility === 'only-me') {
                filteredData.review = undefined;
                filteredData.reviewVisibility = undefined;
            }
            return filteredData;
        });
    }
    /**
     * Check if a review should be visible to a specific viewer
     */
    static isReviewVisibleToViewer(reviewVisibility, reviewOwnerUserId, viewerUserId) {
        if (!viewerUserId) {
            return reviewVisibility === 'anyone' || !reviewVisibility;
        }
        if (viewerUserId === reviewOwnerUserId) {
            return true;
        }
        switch (reviewVisibility || 'anyone') {
            case 'anyone':
                return true;
            case 'only-me':
                return false;
            default:
                return true;
        }
    }
    /**
     * Get privacy icon name for UI display
     */
    static getPrivacyIconName(visibility) {
        switch (visibility || 'anyone') {
            case 'only-me':
                return 'Lock';
            case 'anyone':
            default:
                return 'Public';
        }
    }
    /**
     * Get privacy text for UI display
     */
    static getPrivacyText(visibility) {
        switch (visibility || 'anyone') {
            case 'only-me':
                return 'Only you can see this';
            case 'anyone':
            default:
                return 'Everyone can see this';
        }
    }
    /**
     * Validate privacy setting
     */
    static validatePrivacySetting(visibility) {
        if (visibility === 'only-me' || visibility === 'anyone') {
            return visibility;
        }
        return 'anyone';
    }
}
exports.ReviewPrivacyService = ReviewPrivacyService;
